import { FileText, Plus, X } from "lucide-react";
import React, { useState } from "react";
import { CLOUD_UPLOAD } from "../../../../../assets";

import SuccessModal from "../../../../../shared/components/successModal";

function FileNewProcess() {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [documents, setDocuments] = useState<
    { id: string; file: File | null }[]
  >([{ id: "1", file: null }]);
  const handleFileUpload = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string,
  ) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const newDocuments = documents.map((doc) =>
        doc.id === id ? { ...doc, file } : doc,
      );
      setDocuments(newDocuments);
    }
  };

  const addDocumentSlot = () => {
    setDocuments([...documents, { id: Date.now().toString(), file: null }]);
  };

  const removeDocumentSlot = (index: number | string) => {
    if (documents.length > 1) {
      setDocuments(documents.filter((doc) => doc.id !== index));
    }
  };
  return (
    <div className="w-full flex items-center py-20 flex-col justify-center">
      <span className="text-[28px] font-semibold">File a process</span>
      <div className="w-[500px] p-10 h-full bg-white shadow-lg flex flex-col gap-y-4">
        <span className="text-lg font-semibold">Upload case documents</span>

        <div className="flex flex-col items-start gap-y-0.5">
          <span className="text-[14px] font-normal text-[#344054]">Party</span>
          <input
            type="text"
            placeholder="plaintiff"
            className="w-full p-3 text-xs placeholder:text-[#667085] border border-[#EAECF0] rounded"
          />
        </div>
        <div className="flex flex-col items-start gap-y-0.5">
          <span className="text-[14px] font-normal text-[#344054]">
            Party type
          </span>
          <select className="w-full p-3 outline-none text-xs placeholder:text-[#667085] border border-[#EAECF0] rounded">
            <option value="Plaintiff">Plaintiff</option>
            <option value="Defendant">Defendant</option>
            <option value="Third Party">Third Party</option>
          </select>
        </div>
        <div className="flex flex-col items-start gap-y-0.5">
          <span className="text-[14px] font-normal text-[#344054]">
            Document name
          </span>
          <input
            type="text"
            placeholder="Input document name here"
            className="w-full p-3 text-xs placeholder:text-[#667085] border border-[#EAECF0] rounded"
          />
        </div>
        <div className="flex flex-col items-start gap-y-0.5">
          <span className="text-[16px] font-semibold text-[#344054]">
            Upload documents
          </span>
          <div className="flex flex-col gap-y-4 w-full mt-3">
            {documents.map((doc, idx) => (
              <div key={doc.id} className="w-full relative">
                <input
                  type="file"
                  id={`file-upload-${doc.id}`}
                  accept="application/pdf"
                  onChange={(e) => handleFileUpload(e, doc.id)}
                  className="hidden"
                />
                {doc.file ? (
                  <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-[#E9EAEB]">
                    <div className="flex items-center gap-x-3">
                      <FileText className="w-6 h-6 text-[#00B074]" />
                      <span className="text-sm font-medium text-[#1A1A1A] truncate max-w-[200px]">
                        {doc.file.name}
                      </span>
                    </div>
                    <div className="flex items-center gap-x-3">
                      <button
                        onClick={() => {
                          if (doc.file) {
                            const url = URL.createObjectURL(doc.file);
                            window.open(url, "_blank");
                          }
                        }}
                        className="text-sm font-medium text-[#00B074] hover:underline"
                      >
                        View
                      </button>
                      <label
                        htmlFor={`file-upload-${doc.id}`}
                        className="text-sm font-medium text-[#1A1A1A] cursor-pointer hover:underline"
                      >
                        Change
                      </label>
                      <button
                        onClick={() => {
                          if (documents.length > 1) {
                            removeDocumentSlot(doc.id);
                          } else {
                            const newDocs = [...documents];
                            newDocs[idx].file = null;
                            setDocuments(newDocs);
                          }
                        }}
                        className="text-red-500 hover:text-red-700"
                      >
                        <X className="w-5 h-5" />
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="w-full border-2 border-dashed border-[#E9EAEB] rounded-xl p-8 flex flex-col items-center justify-center gap-y-2 bg-white hover:bg-gray-50 transition-colors cursor-pointer relative">
                    <label
                      htmlFor={`file-upload-${doc.id}`}
                      className="absolute inset-0 w-full h-full cursor-pointer"
                    />
                    <img
                      src={CLOUD_UPLOAD}
                      alt="cloud-upload"
                      className="w-10 h-10"
                    />
                    <div className="text-center">
                      <span className="text-[#00B074] font-bold">
                        Click to upload
                      </span>
                      <span className="text-[#475467]"> Example case.pdf</span>
                    </div>
                    <span className="text-[#475467] text-xs">
                      PDF only (max. 5 MB)
                    </span>
                    {documents.length > 1 && (
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          removeDocumentSlot(doc.id);
                        }}
                        className="absolute top-2 right-2 text-red-500 hover:text-red-700 z-10"
                      >
                        <X className="w-5 h-5" />
                      </button>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="self-end mt-2">
          <div
            onClick={addDocumentSlot}
            className="w-8 h-8 rounded-full bg-[#00B074] flex items-center justify-center text-white cursor-pointer hover:bg-[#009b65]"
          >
            <Plus className="w-5 h-5" />
          </div>
        </div>
        <button
          onClick={() => setIsSuccessModalOpen(true)}
          className="w-full bg-[#00B074] text-white py-4 rounded-xl font-medium text-lg hover:bg-[#009b65] transition-colors mt-8"
        >
          Next
        </button>
      </div>
      <SuccessModal
        open={isSuccessModalOpen}
        close={() => setIsSuccessModalOpen(false)}
        message="Submitted successfully"
      />
    </div>
  );
}

export default FileNewProcess;
